<template>
  <div>
    <div class="contact-info">
      <button @click="editSetting" class="edit-button mx-5">
        <i class="fa fa-edit"></i> تعديل الإعدادات العامة
      </button>
    </div>
    <div v-if="generalSetting" class="contact-container contact-card">
      <div class="contact-item">
        <div class="contact-info">
          <div class="contact-title">
            <i class="fas fa-map-marker-alt" style="color: #007bff"></i> العنوان
            بالإنجليزية
          </div>
          <div>{{ generalSetting.location_en }}</div>
        </div>
      </div>

      <div class="contact-item">
        <div class="contact-info">
          <div class="contact-title">
            <i class="fas fa-map-marker-alt" style="color: #007bff"></i> العنوان
            بالعربية
          </div>
          <div>{{ generalSetting.location_ar }}</div>
        </div>
      </div>

      <div class="contact-item">
        <div class="contact-info">
          <div class="contact-title">
            <i class="fab fa-facebook" style="color: #0268e2"></i> فيسبوك
          </div>
          <div v-if="generalSetting.facebooklink">
            {{
              generalSetting.facebooklink.replace(
                "https://www.facebook.com/",
                ""
              )
            }}
          </div>
        </div>
      </div>

      <div class="contact-item">
        <div class="contact-info">
          <div class="contact-title">
            <i class="fab fa-instagram" style="color: #c13584"></i> إنستجرام (1)
          </div>
          <div v-if="generalSetting.instagramlink_1">
            {{
              generalSetting.instagramlink_1.replace(
                "https://www.instagram.com/",
                ""
              )
            }}
          </div>
        </div>
      </div>

      <div class="contact-item">
        <div class="contact-info">
          <div class="contact-title">
            <i class="fab fa-instagram" style="color: #c13584"></i> إنستجرام (2)
          </div>
          <div v-if="generalSetting.instagramlink_2">
            {{
              generalSetting.instagramlink_2.replace(
                "https://www.instagram.com/",
                ""
              )
            }}
          </div>
        </div>
      </div>

      <div class="contact-item">
        <div class="contact-info">
          <div class="contact-title">
            <i class="fas fa-phone" style="color: #1b407d"></i> رقم الهاتف
          </div>
          <div>{{ generalSetting.phone_1 }}</div>
        </div>
      </div>

      <div class="contact-item">
        <div class="contact-info">
          <div class="contact-title">
            <i class="fab fa-whatsapp" style="color: #319431"></i> واتساب
          </div>
          <div>{{ generalSetting.phone_2 }}</div>
        </div>
      </div>

      <div class="contact-item">
        <div class="contact-info">
          <div class="contact-title">
            <i class="fas fa-envelope" style="color: #ef7f77"></i> البريد
            الإلكتروني
          </div>
          <div>{{ generalSetting.email }}</div>
        </div>
      </div>
      <div class="contact-item">
        <div class="contact-info">
          <div class="contact-title">
            <i class="fas fa-dollar" style="color: green"></i>سعر الدولار
          </div>
          <div>{{ generalSetting.exchangeRate }}</div>
        </div>
        <div class="contact-info">
          <div class="contact-title">
            <i class="fas fa-arrow-up" style="color: blue"></i>اضغط
            <span class="clickHere" @click="openIncModal">هنا</span> لزيادة
            الأسعار
          </div>
        </div>
        <div class="contact-item">
          <div class="contact-info">
            <div class="contact-title">
              <i class="far fa-map" style="color: rgb(224, 195, 32)"></i>
              العنوان على الخريطة
            </div>
            <MapView
              style="width: 60%; height: 250px; margin: auto; z-index: 1"
            />
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="generalSetting"
      class="container containerForm p-5"
      style="text-align: center; background-color: #f3f1f0"
    >
      <h3>صور السلايدر (الصفحة الرئيسية)</h3>
      <button class="add-button" @click="addNewImage">
        <i class="fa fa-plus"></i> إضافة صورة جديدة
      </button>
      <div class="image-container">
        <div
          class="image-card"
          v-for="(slide, indexKey) in sliderImages"
          :key="slide.index"
        >
          <div class="image-card-container">
            <div class="delete-button" @click="deleteSlide(indexKey)">
              <i class="fa fa-times"></i>
            </div>
            <div
              class="image-card-content"
              style="cursor: pointer"
              @click="openImageModal(indexKey)"
            >
              <vue-load-image>
                <template v-slot:image>
                  <img
                    :src="
                      'https://jebsenboard.onrender.com/image/Sliders/' + slide.imgName
                    "
                    alt="Slider Image"
                  />
                </template>
                <template v-slot:preloader>
                  <div
                    class="spinner-border text-primary"
                    role="status"
                    style="text-align: center"
                  >
                    <span class="sr-only">Loading...</span>
                  </div>
                </template>
                <template v-slot:error>Image load fails</template>
              </vue-load-image>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Image Modal -->
    <b-modal v-model="isModalOpen" title="عرض الصورة" size="lg">
      <img
        :src="getImageUrl(clickedImageIndex)"
        alt="Clicked Image"
        class="ModalImage"
      />
    </b-modal>

    <b-modal v-model="isIncModalOpen" title="زيادة أسعار المنتجات">
      <div style="text-align: center">
        <p>كم نسبة زيادة الأسعار؟</p>
        <small class="text-danger mb-3"
          >* علمًا بأن هذه النسبة ستطبق على جميع المنتجات</small
        >
        <input
          v-model="percentage"
          type="number"
          placeholder="أدخل الرقم"
          class="incPriceInput"
        />
      </div>
      <button
        style="margin-right: 40%"
        class="btn btn-primary"
        @click="increasePrice"
      >
        حفظ
      </button>
    </b-modal>
  </div>
</template>

<script>
import Axios from "../../../Axios";
import Swal from "sweetalert2";
import MapView from "../../../Website/SharedUI/MapView";
import { BModal } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "./GeneralSetting.css";
import VueLoadImage from "vue-load-image";

export default {
  components: {
    MapView,
    BModal,
    "vue-load-image": VueLoadImage,
  },
  data() {
    return {
      generalSetting: {},
      slides: [],
      clickedImageIndex: null,
      isModalOpen: false,
      isIncModalOpen: false,
      percentage: 0,
      sliderImages: [],
    };
  },
  mounted() {
    this.fetchGeneralSetting();
    this.fetchSliderImages();
  },
  methods: {
    increasePrice() {
      Axios.patch(
        `/dashboard/productsIncPrice`,
        { percentage: this.percentage },
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
        .then((response) => {
          this.fetchGeneralSetting();
          this.$iziToast.success({
            timeout: 2000,
            message: "تم زيادة الأسعار بنجاح",
            position: "bottomRight",
          });
          this.closeIncModal();
        })
        .catch((error) => {
          // console.error(error);
          this.$iziToast.error({
            timeout: 3000,
            message: "برجاء إدخال رقم صحيح",
            position: "bottomRight",
          });
        });
    },
    openImageModal(index) {
      this.clickedImageIndex = index;
      this.isModalOpen = true;
    },
    closeImageModal() {
      this.isModalOpen = false;
    },
    openIncModal() {
      this.isIncModalOpen = true;
    },
    closeIncModal() {
      this.isIncModalOpen = false;
    },
    addNewImage() {
      // Assuming you have a file input to select new image files
      const fileInput = document.createElement("input");
      fileInput.type = "file";
      fileInput.accept = "image/*";
      fileInput.multiple = true; // Allow multiple image selection
      fileInput.addEventListener("change", (event) => {
        const imageFiles = Array.from(event.target.files);

        const formData = new FormData();
        imageFiles.forEach((imageFile) => {
          formData.append("image", imageFile);
        });

        Axios.post(`/slidderImg/`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
          .then((response) => {
            // console.log(response);
            this.fetchGeneralSetting();
            this.$iziToast.success({
              timeout: 3000,
              message: "تم إضافة الصورة بنجاح",
              position: "bottomRight",
            });
            this.fetchSliderImages();
          })
          .catch((error) => {
            // console.error(error.response.data.message);

            if (error.response && error.response.data) {
              const errorMessage = error.response.data.message;
              this.$iziToast.error({
                timeout: 5000,
                message: errorMessage,
                position: "bottomRight",
              });
              if (
                error.response.data.message == "MulterError: Unexpected field"
              ) {
                this.$iziToast.error({
                  timeout: 4000,
                  message: "لا يمكنك إضافة أكثر من صورة في المرة الواحدة",
                  position: "bottomRight",
                });
              }
            }
          });
      });

      // Trigger the file input dialog
      fileInput.click();
    },

    deleteSlide(indexDel) {
      // Use SweetAlert for confirmation
      Swal.fire({
        title: "هل أنت متأكد من حذف تلك الصورة؟",
        text: "لن تتمكن من إسترجاعها بعد ذلك",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "قم بالحذف",
        cancelButtonText: "إلغاء",
      }).then((result) => {
        if (result.isConfirmed) {
          // Check if the image exists at the specified index
          if (
            this.sliderImages &&
            this.sliderImages[indexDel]
          ) {
            // User confirmed, proceed with deletion
            Axios.delete(
              `/slidderImg/${this.sliderImages[indexDel].id}`
            )
              .then((response) => {
                // If the deletion is successful, remove the image from the slides array
                Swal.fire("تم الحذف!", "تم حذف الصورة بنجاح", "success");
                this.fetchSliderImages();
              })
              .catch((error) => {
                // console.error(error);
              });
          } else {
            // Handle the case where the image does not exist at the specified index
            Swal.fire("خطأ", "قم بإعادة تحميل الصفحة وحاول مجددًا", "error");
          }
        }
      });
    },

    getImageUrl(index) {
      if (this.sliderImages[index]) {
        return "https://jebsenboard.onrender.com/image/Sliders/"+this.sliderImages[index].imgName;
      }
      return "";
    },
    editSetting() {
      this.$router.push("/admin/edit-setting");
    },
    fetchGeneralSetting() {
      Axios.get("/generalSetting")
        .then((response) => {
          this.generalSetting = response.data;
        })
        .catch((error) => {
          // console.error(error);
        });
    },
    fetchSliderImages() {
      Axios.get("https://jebsenboard.onrender.com/slidderImg")
        .then((response) => {
          // console.log(response.data);
          this.sliderImages = response.data;
        })
        .catch((error) => {
          // console.error(error);
        });
    },
  },
};
</script>
